import {  Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    { 
      path: '', 
	    canActivate: [MsalGuard],
      loadChildren: () => import('./pages/pages.routing').then(m => m.PagesRoutes)
    }
];
